import { Button, Col, Row } from "react-bootstrap";
import IconSvg from "../../../../SharedComponents/IconSvg";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";

/**
 * Reusable image upload field component
 * Handles display, upload, and deletion of images
 */
const ImageUploadField = ({
  label,
  imageState,
  existingImageName,
  onFileSelect,
  onDelete,
  dimensions = { width: 210, height: 297 },
  maxFileSize = 500 * 1024,
  accept = "image/png, image/jpeg, image/webp",
}) => {
  const { file, value, preview, isDeleted } = imageState;
  const hasImage = (existingImageName && !isDeleted) || preview;

  const handleFileChange = (e) => {
    const result = onFileSelect(e, maxFileSize);
    if (result && !result.success) {
      alert(result.error);
    }
  };

  const getImageSrc = () => {
    if (preview) {
      return preview;
    }
    if (existingImageName && !isDeleted) {
      return ApiHelper.cloudFrontURL + folderEnum.info + existingImageName;
    }
    return ApiHelper.cloudFrontURL + folderEnum.info + "null";
  };

  return (
    <Row>
      <Col xs={"auto"} className={"align-content-center"}>
        <div className={"fw-semibold text-18"}>{label}</div>
        {hasImage ? (
          <Button size="sm" variant="danger" style={{ margin: "10px" }} onClick={onDelete}>
            <IconSvg icon="trash-can" fill="#fff" />
          </Button>
        ) : (
          <input type="file" accept={accept} value={value} onChange={handleFileChange} />
        )}
      </Col>
      <Col xs={"auto"}>
        <img
          src={getImageSrc()}
          alt={label}
          height={dimensions.height}
          width={dimensions.width}
          style={{ objectFit: "contain" }}
        />
      </Col>
    </Row>
  );
};

export default ImageUploadField;
